// tslint:disable-next-line:typedef
const formRules = {
  isRequired: (v: any) => !!v || "This field is required",
  selectCompany: (v: number) => {
    return v > -1 || "A company is required";
  },
  isNumber: (v: any) => {
    if (v === null || v === undefined) return true;
    return Number(v) >= 0 || "A positive number is required";
  },
  isAnyNumber: (v: any) => {
    if (v === null || v === undefined) return true;
    return !isNaN(parseFloat(v)) || "A number is required";
  },
  maxChar150: (v: string) => String(v).length <= 150 || "Maximum 150 characters allowed",
  maxChar50: (v: string) => String(v).length <= 50 || "Maximum 50 characters allowed",
  validEmail: (v: string) =>
    new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(v) || "Invalid E-mail",
  validName: (v: string) =>
    new RegExp(/([-',.a-z]{0,23}[a-z])/, "i").test(v) ||
    "Invalid Name. Two words that can only Start and End with an a-z, maximum 25 characters and cannot contain symbols",
  validPassword: (v: string) =>
    new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#!%*^?&])[A-Za-z\d@$#!%*^?&]{6,}$/).test(
      v
    ) ||
    "Invalid Password. At least one character, digit, symbol and one capitalized character. Minimum 6 length."
};
export default formRules;
